// extracted by mini-css-extract-plugin
export default {"content":"RegisterSubmission_content__lVahC"};